import { Typography } from 'antd'
import React, { FunctionComponent, useState } from 'react'
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { PaymentScheduleItem } from '../../utils/loanCalculatorHelpers'

const { Title } = Typography

interface LoanPaymentChartProps {
  data: PaymentScheduleItem[]
}

export const LoanPaymentChart: FunctionComponent<LoanPaymentChartProps> = ({
  data,
}) => {
  const [isVisible, setIsVisible] = useState(false)

  if (!data || data.length === 0) return null

  const handleToggle = () => {
    setIsVisible(prev => !prev)
  }

  const formatCurrency = (value: number) => {
    return `${value.toLocaleString('cs-CZ')} Kč`
  }

  return (
    <div className="mt-8">
      <Title
        level={4}
        className="mb-4 cursor-pointer select-none"
        onClick={handleToggle}
      >
        Vývoj splácení v čase {isVisible ? '⇡' : '⇣'}
      </Title>

      {isVisible && (
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
          >
            <defs>
              <linearGradient id="colorPrincipal" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#52c41a" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#52c41a" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorInterest" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ff7a45" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#ff7a45" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="month"
              label={{
                value: 'Měsíc',
                position: 'insideBottom',
                offset: -5,
              }}
            />
            <YAxis
              yAxisId="left"
              tickFormatter={value => `${(value / 1000).toFixed(0)}k`}
              label={{
                value: 'Zbývající částky (Kč)',
                angle: -90,
                position: 'insideLeft',
              }}
            />
            <Tooltip
              formatter={(value: number) => formatCurrency(value)}
              labelFormatter={(label: number) => `Měsíc ${label}`}
            />
            <Legend verticalAlign="top" height={36} />
            <Area
              yAxisId="left"
              type="monotone"
              dataKey="remainingPrincipal"
              stackId="1"
              stroke="#52c41a"
              fill="url(#colorPrincipal)"
              name="Zbývající jistina"
            />
            <Area
              yAxisId="left"
              type="monotone"
              dataKey="remainingInterest"
              stackId="1"
              stroke="#ff7a45"
              fill="url(#colorInterest)"
              name="Zbývající úrok"
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="remainingBalance"
              stroke="#1890ff"
              strokeWidth={2}
              dot={false}
              name="Zbývající dluh"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}

      {/* <div className="mt-4 text-sm text-gray-600">
        <p>
          Graf zobrazuje zbývající částky ke splacení v průběhu času. Zelená
          plocha představuje zbývající jistinu, oranžová zbývající úroky, které
          ještě zaplatíte. Modrá linie ukazuje celkový zbývající dluh (součet
          zbývající jistiny a úroků).
        </p>
      </div> */}
    </div>
  )
}
